import { useContext, useEffect, useState } from 'react';
import { useYoConfigSnapshots } from '@yakoffice/yakoffice-firebase';
import { useYoProjectsSnapshots } from '@yakoffice/yakoffice-firebase';
import { AuthUserContext } from '@yakoffice/yakoffice-firebase';

export const useMobileNavigation = () => {

  const authUser = useContext(AuthUserContext);
  const { yoConfig, error: yoConfigError } = useYoConfigSnapshots();
  const { yoProjects, error: yoProjectsError } = useYoProjectsSnapshots();
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
      if (yoConfigError != null)
        setError(yoConfigError);

      if (yoProjectsError != null)
        setError(yoProjectsError);

    }, [yoConfigError, yoProjectsError]
  );

  const isDevSite = () => hostedOnYakOfficeAppUrl(window.location.hostname);

  return { authUser, yoConfig, yoProjects, error, isDevSite };
};

const hostedOnYakOfficeAppUrl = (url: string) => !url.match(/yakoffice.app/g);
